// Route guard. `min` is the capability required:
//   'super'  → superadmin
//   'groups' → can create / run groups (Group Leader, Publisher, superadmin)
//   'events' → can create / run events (Event Leader, Publisher, superadmin)
//   'leader' → legacy alias for 'groups' (design/021)
import { useRole } from '../app/RoleContext';
import AccessDenied from './AccessDenied';

export default function RequireRole({ min, children }) {
  const { canSeeAdmin, canManageGroups, canCreateEvents } = useRole();

  if (min === 'super') {
    if (canSeeAdmin) return children;
    return (
      <AccessDenied title="Admin tools require superadmin">
        Only the platform superadmin (the <code>is_admin</code> flag on the persons
        table) can open this page. Use the dev role switch to preview as superadmin.
      </AccessDenied>
    );
  }
  if (min === 'events') {
    if (canCreateEvents) return children;
    return (
      <AccessDenied title="Event tools require the Event Leader role">
        Creating and running events is available to Event Leaders, Publishers and superadmins.
      </AccessDenied>
    );
  }
  if (canManageGroups) return children;
  return (
    <AccessDenied title="Group tools require the Group Leader role">
      Creating and running groups is available to Group Leaders, Publishers and superadmins.
    </AccessDenied>
  );
}
